import axios from 'axios';

const STORAGE_KEY = 'moderatorCompanyHost';

export function getModeratorCompanyHost() {
  return localStorage.getItem(STORAGE_KEY) || '';
}

export function setModeratorCompanyHost(domain) {
  if (domain) {
    localStorage.setItem(STORAGE_KEY, domain);
    axios.defaults.headers.common['X-Company-Host'] = domain;
  } else {
    localStorage.removeItem(STORAGE_KEY);
    delete axios.defaults.headers.common['X-Company-Host'];
  }
  window.dispatchEvent(new CustomEvent('moderator-company-scope-changed', { detail: { domain: domain || '' } }));
}

export function applyModeratorCompanyHostFromStorage() {
  const domain = getModeratorCompanyHost();
  if (domain) {
    axios.defaults.headers.common['X-Company-Host'] = domain;
  } else {
    delete axios.defaults.headers.common['X-Company-Host'];
  }
}
